import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../common/CommonStyledComponents';
import { priceFormat } from '../../../util';

class OrderSummaryBox extends Component {
  static propTypes = {
    currencyCode: PropTypes.string.isRequired,
    subtotal: PropTypes.number.isRequired,
    tax: PropTypes.number.isRequired,
    shipping: PropTypes.number.isRequired,
    discount: PropTypes.number.isRequired,
    custom: PropTypes.object,
  };

  customFieldOption = {
    referrals_advocate_credit_amount: {
      name: 'Advocate credit',
      minus: true,
    },
    referrals_friend_credit_amount: {
      name: 'Friend credit',
      minus: true,
    },
    betabrand_store_credit_amount: {
      name: 'Store credit',
      minus: true,
    },
    betabrand_crowdfunding_discount_amount: {
      name: 'Crowdfunding discount',
      minus: true,
    },
  };

  renderCustomFields() {
    const { custom = {} } = this.props;

    const customComponents = Object.keys(custom).reduce((acc, key) => {
      const option = this.customFieldOption[key] || null;
      if (option && custom[key] > 0) {
        const minus = option.minus ? '-' : '';
        acc.push([
          <Styled.RowContent>
            <div>{option.name}</div>
            <div>{`${minus}${this.priceFormat(custom[key].toFixed(2))}`}</div>
          </Styled.RowContent>,
        ]);
      }

      return acc;
    }, []);

    if (customComponents.length) {
      customComponents.push(<Styled.Divider />);

      return customComponents;
    }

    return null;
  }

  priceFormat = (value) => priceFormat(value, this.props.currencyCode);
  render() {
    const { subtotal, tax, shipping, discount, total } = this.props;
    const discountMinus = discount === 0 ? '' : '-';

    return (
      <Styled.OrderSummaryBox>
        <Styled.OrderSummaryHeader>Refund Summary:</Styled.OrderSummaryHeader>
        <Styled.OrderSummaryInfo>
          <Styled.RowContent>
            <div>Subtotal</div>
            <div>{this.priceFormat(subtotal.toFixed(2))}</div>
          </Styled.RowContent>
          <Styled.RowContent>
            <div>Discount</div>
            <div>{`${discountMinus}${this.priceFormat(discount.toFixed(2))}`}</div>
          </Styled.RowContent>
          <Styled.RowContent>
            <div>Tax</div>
            <div>{this.priceFormat(tax.toFixed(2))}</div>
          </Styled.RowContent>
          <Styled.RowContent>
            <div>Shipping</div>
            <div>{this.priceFormat(shipping.toFixed(2))}</div>
          </Styled.RowContent>
          <Styled.Divider />

          {this.renderCustomFields()}

          <Styled.RowContent>
            <Styled.OrderSubtotalInfo>Refund total</Styled.OrderSubtotalInfo>
            <Styled.OrderSubtotalInfo>{this.priceFormat(total.toFixed(2))}</Styled.OrderSubtotalInfo>
          </Styled.RowContent>
        </Styled.OrderSummaryInfo>
      </Styled.OrderSummaryBox>
    );
  }
}

export default OrderSummaryBox;
